import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import TextBlock from "../../../components/sections/front/Common/TextBlock";
import SectionTakeAction from "../../../components/sections/front/TakeAction/SectionTakeAction";
import { useBanner } from "../../../providers/BannerProviders";
import { Helmet } from "react-helmet-async";

const TakeAction = () => {
  const { data } = useBanner();
  const takeActionBanner = data?.data?.find(
    (item) => item?.bannerType === "takeAction"
  );

  return (
    <>
      {takeActionBanner && (
        <Helmet>
          <title>{takeActionBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={takeActionBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={takeActionBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={takeActionBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <PageBanner
        title={takeActionBanner?.title}
        image={takeActionBanner?.image?.url}
      />
      <TextBlock description={takeActionBanner?.description} />
      <SectionTakeAction data={takeActionBanner} />
      <OurPartners />
    </>
  );
};

export default TakeAction;
